<p>operation-events-card works!</p>
